import Footer from "./components/Footer";
import { Security, SecurityImg, SecurityText } from "./components/Footer/styles";
import Routes from "./routes";
import { Container } from "./styles";

function App() {
  return (
    <Container>
      <div className="login__area">
        <div className="login__header">
          <div className="login__logo-container">
            <a href="https://www.zonasul.com.br">
              <img className="login__logo" src="https://zonasul.vtexassets.com/arquivos/logo_zonasul.svg?v=1" alt="Logo do Supermercado Zonasul" />
            </a>
          </div>
        </div>
        <Routes />
      </div>

      <div className="login__footer">
        <Security>
          <SecurityImg src="https://zonasul.vtexassets.com/arquivos/icone-seguranca.svg" alt="ícone segurança" />
          <SecurityText>Ambiente Seguro</SecurityText>
        </Security>
      </div>

      <Footer />
    </Container>
  );
}

export default App;
